import { IonCol, IonContent, IonGrid, IonInput, IonPage, IonRow, IonText ,IonIcon,IonSpinner} from "@ionic/react"
import moment from "moment"
import { useEffect, useState,useMemo} from "react"
import { useHistory,useLocation } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import Select from 'react-select';
import service from "../../Service/service"
import Head from "../Header"
import Sidebar from "../Sidebar"
import swal from 'sweetalert'
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import "../../theme/style2.css"

const ProjectReport: React.FC = () => {
    const history = useHistory();
    const location: any = useLocation();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
            if (location.state) {
                console.log(location)
                setId(location.state.projectId)    
            }
        }
    }, [token, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [business, setBusiness] = useState("");
    const [id, setId] = useState("");

    const [clientName, setClientName] = useState("");
    const [clientView, setClientView] = useState([]);

    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const [updatedBy] = useState(localStorage.getItem("SignupEmpId"));

    const [bussinessUnitArr, setBussinessUnitArr] = useState([]);
    const [bussinessUnitArr1, setBussinessUnitArr1]: any = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const [projectManagerArr, setProjectManagerArr] = useState([]);
    const [isEdit, setIsEdit] = useState(true);
    const [statusList, setStatusList] = useState([]);
    const [statusId,setStatusId] = useState([])
    const [projectStatusId, setProjectStatusId] = useState("")
    const [loading,setloading]=useState(false)
    const hanldeStatusType = (e: any) => {
        setProjectStatusId(e.target.value)
    }

//.................Project Status Autocomplete........................//

const [selectedOption9, setSelectedOption9] = useState(null);
const [inputValue9, setInputValue9] = useState('');
const [isFocused9, setIsFocused9] = useState(false);
const [menuIsOpen9, setMenuIsOpen9] = useState(false);

const handleStateChange9 = (selectedOption9: any) => {
    setSelectedOption9(selectedOption9);
};

const handleInputChange9 = (inputValue9: any) => {
    setInputValue9(inputValue9);
};

const handleMenuOpen9 = () => {
    setMenuIsOpen9(true);
};

const handleMenuClose9 = () => {
    setMenuIsOpen9(false);
};

const handleFocus9 = () => {
    setIsFocused9(true);
};

const handleBlur9 = () => {
    setIsFocused9(false);
};

const Placeholder9 = () => {
    if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
        return <span style={{ color: "black" }}>Open</span>;
    } else {
        return <span style={{ color: "black" }}>Type to Search Here...</span>;
    }
};

const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
        if (isClicked && !selectProps.menuIsOpen9) {
            setIsClicked(false);
        }
    }, [selectProps.menuIsOpen9]);

    let icon;
    if (isClicked || selectProps.menuIsOpen) {
        icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
    } else {
        icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
    }

    const handleIconClick = () => {
        setIsClicked(true);
    };

    return (
        <div {...innerProps}>
            <div onClick={handleIconClick}>{icon}</div>
        </div>
    );
};
const options9 = statusList.map((state: any) => ({
    value: state.id,
    label: state.status,
}));

const hanldeStatusTypes = (selectedOption9: any) => {
    setProjectStatusId(selectedOption9.value)
}


    /*............ Assign Project............... */

    const inputArr1 = [
        {
            employeeId: "",
            projectId: "",
            assignedBy: "",
            responsibilities: "",
            businessUnitId: ""
        }
    ];

    const [project, setProject] = useState(inputArr1)
    const [assigntable, setAssigntable] = useState([]);
    const [prjName, setPrjName] = useState("");
    const [projectId, setProjectId] = useState("");

    const [nameView, setNameView]: any = useState([0]);

    const [assign]: any = useState(localStorage.getItem("SignupEmpId"));

    const [assignId, setAssignId]: any = useState([]);
    
//--------------------Navigate to viewpage--------------------//

    const Views = (projectId: any ,projectName:any) => {
        console.log("project id:", projectId,"project Name:",projectName);
        history.push({ pathname: "/ProjectReportView", state: { projectId: projectId, projectName:projectName  } });
    }
    // ----------------------Get status list ---------------------

 const GetStatusList = () => {
    
    service.GetPrjClsStatuslist()
        .then((response) => {
            console.log(response);
            if (response.status === 200) {
                setStatusList(response.data);
            }
            else {
                setStatusList([])
            }
        })
}
//--------------------Getall project Data table---------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
             width: "83px",
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            cell: (itm: any) => {
                if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
                    return itm.businessUnit.businessUnitName;
                } else {
                    return 'NA';
                }
            },

            sortable: true,
            sort:"businessUnitName",
            width: "150px",
        },
        {
            name: "Department",
            selector: (itm: any) => {
                if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
                    return itm.masterDepartment.departmentName;
                } else {
                    return 'NA';
                }
            },
            sortable: true,
            sort:"departmentName",
            width: "135px",
        },
        {
            name: "Project Name",
            selector: (itm: any) => itm.projectName,
            sortable: true,
            width: "215px",
        },
        {
            name: "Created Date",
            selector: (itm: any) => itm.createdDate,
            sortable: true,
            // width: "00px",
            sort:"createdDate",
            cell: (itm: any) => {
                var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
                return (
                    <>
                        <IonText>{crDate}</IonText>
                    </>
                )
            },
            width: "145px"
           
        },
        {
            name: "Created By",
            selector: (itm: any) => itm.createdBy,
            sortable: true,
             width: "135px"

        },
        // {
        //     name: "No.Of Resources",
        //     selector: (itm: any) => itm.noOfResources,
        //     sortable: true,
        //     width: "170px"
        // },
        {
            name: "Resources",
            selector: (itm: any) => itm.noOfResources,
            sortable: true,
            width: "121px",
            cell: (row:any) => {
                return (
                    <div style={{ textAlign: 'center' }}>
                        {row.noOfResources}
                    </div>
                );
            }
        },        
           {
            name: "Status",
            // selector: (itm: any) => itm.projectStatus.status,
            sortable: true,
            width: "120px",
            cell: (itm: any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {itm.projectStatus.status === "Open" ? (
                        <p style={{ color: "#00b700", margin: '0' }}>Open</p>
                    ) : itm.projectStatus.status === "Hold" ? (
                        <p style={{ color: "orange", margin: '0' }}>Hold</p>
                    ) : (
                        <p style={{ color: "red", margin: '0' }}>Close</p>
                    )}
                </div>

            )
        },
        {
            name: "View",
            sortable: false,
            // width: "75px",
            cell: (itm: any) => (
                <div>
                    <IonText onClick={() => Views(itm.id,itm.projectName)} style={{ color: "coral", cursor: 'pointer', fontSize: '14px', padding: "2px" }}>View</IonText>
                </div>
            )
        },

    ];


    const customStyles = {
        headRow: {
            style: {
                width:"100%"
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    //----------------search filter---------------------//
    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        
        };
    
    return (
        <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
                <div className="form-group form-focus row">
                    <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                        value={filterText} placeholder="Search" />
                    <label className="focus-label">Search</label>
                </div>
                <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
            </div>
        </div>
    )
    
    }, [filterText, resetPaginationToggle]);

    //-----------------Getall Projects Api-----------------//
    
    useEffect(() => {
        var role = localStorage.getItem("UserRole")
        console.log(role, "kmk")
        if (role === "MANAGER" || role === "Manager") {
            setIsEdit(false)
        }
        else {
            setIsEdit(true)
        }
        //AllClients();
        LoadProject();
        GetStatusList();
        //ViewAllBusinessunitDropDown();
    }, [])

    const LoadProject = () => {
        setloading(true);
        service.GetallProject(createdBy, projectStatusId)
            .then((response) => {
                console.log(response);
                if (response.data.status === "400") {
                    setData([]);
                } else {
                    setData(response.data.Data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                // This code will execute whether the promise is resolved or rejected
                setTimeout(() => {
                    setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                }, 500); // Adjust the timeout duration as needed
            });
    }

    // const AllClients = () => {
    //     service.GetAllClientNameDropDown()
    //         .then((response) => {
    //             console.log("All Client")
    //             console.log(response);
    //             if (response.data.status === "200") {
    //                 setClientView(response.data.data)
    //             }
    //             else {
    //                 setClientView([])
    //             }
    //         })
    // }

    // const ProjectManagerView = (Id: any) => {
    //     service.GetAllEmployeeNames(Id, createdBy)
    //         .then((response) => {
    //             console.log("All Employee Names")
    //             console.log(response)
    //             if (response.data.status === "200") {
    //                 // setNameView(response.data.data)
    //                 setProjectManagerArr(response.data.data)

    //             }
    //             else {
    //                 // setNameView([])
    //                 setProjectManagerArr([])
    //             }
    //         })
    // }
    // const ViewAllBusinessunitDropDown = () => {
    //     service.GetDropDownBusinessUnitOnProject(createdBy)
    //         .then((response) => {
    //             console.log("Bussiness Unit", business)
    //             console.log(response);

    //             if (response.data.Status === "200") {
    //                 setBussinessUnitArr1(response.data.Data)

    //             }
    //             else {
    //                 setBussinessUnitArr1([])
    //             }
    //         })
    // }
    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Select Project </h3>
                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Status </label>
                                        <Select
                                                options={options9}
                                                value={options9.find((option: any) => option.value === projectStatusId) || null}
                                                onChange={hanldeStatusTypes}
                                                onInputChange={handleInputChange9}
                                                onMenuOpen={handleMenuOpen9}
                                                onMenuClose={handleMenuClose9}
                                                onFocus={handleFocus9}
                                                onBlur={handleBlur9}
                                                menuIsOpen={menuIsOpen9}
                                                isSearchable
                                                // disabled={isEdit === true ? false : true}
                                                placeholder={<Placeholder9 />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator9,
                                                }}
                                                className="custom-select0"
                                            />
                                    </div>

                                </div>
                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        // Empresources();
                                        LoadProject();
                                    }} className="btn btn-orange btn-block w-100"> SEARCH </a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
            </IonContent>
        </IonPage>
    )
}

export default ProjectReport
